<template>
  <view>
    <div class="xx"></div>
    <view class="box">
      <image src="/static/img.png" style="width: 100%;height: 150px" />
      <view style="    padding: 47px;">
        <view style="display: flex;align-items: baseline;"><text class="title">尊敬的</text><text class="vlaue">张三 先生/女士</text></view>
        <view style="display: flex;align-items: baseline;"><text class="title">欢迎到访</text><text class="vlaue">深圳中葡数字科技有限公司</text></view>
        <view style="display: flex;align-items: baseline;"><text class="title">有效期</text><text class="vlaue">2023.02.22</text></view>
      </view>
      <tkiBarcode  :val="val" ref="code39"  style="width: 100px;text-align: center;" />

    </view>
  </view>
</template>

<script>
import tkiBarcode from '@/components/tki-barcode/tki-barcode'

export default {
  name: "index",
  components:{
    tkiBarcode
  },
  data(){
    return {
      val: "FB19A1650-100S",
    }
  },
  onLoad(){
    uni.setNavigationBarTitle({ title: '园区通行证',})
    this.$refs.code39._makeCode()
  }
}
</script>

<style scoped>
.box{
  width: 78%;
  background: white;
  height: 500px;
  border-radius: 5px;
  margin: -100px auto 0;
}
.xx{
  height: 0;
  border-top: 144px solid #67a8fa;
  border-right: 720px solid transparent;
}
.title{
  color: #a6afc0;
  font-size: 14px;
  width: 76px;
  flex:0 0 76px;
  display: inline-block;
  line-height: 32px;
}
.vlaue{
  font-size: 14px;

}
</style>
